"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingSpinner = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var LoadingSpinner_module_scss_1 = __importDefault(require("./LoadingSpinner.module.scss"));
var LoadingSpinner = function (_a) {
    var _b;
    var className = _a.className, _c = _a.size, size = _c === void 0 ? 'medium' : _c, _d = _a.inverted, inverted = _d === void 0 ? false : _d, rest = __rest(_a, ["className", "size", "inverted"]);
    return (react_1.default.createElement("div", __assign({ "aria-live": "polite", className: (0, classnames_1.default)(LoadingSpinner_module_scss_1.default['loading-spinner'], LoadingSpinner_module_scss_1.default["loading-spinner--".concat(size)], (_b = {}, _b[LoadingSpinner_module_scss_1.default['loading-spinner--inverted']] = inverted, _b), className), "data-jlds": true, "data-testid": "loading-spinner", role: "status" }, rest)));
};
exports.LoadingSpinner = LoadingSpinner;
//# sourceMappingURL=LoadingSpinner.js.map